<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper default-page bg-white-imp">
      <app-header class="anynomous-header">
      </app-header>
      <main class="content-wrapper mt20">
        <section class="section section-content">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-6-tablet">
                <div class="anomymous-form-wrapper" v-if="showForm">
                  <h3 class="has-text-centered modal-card-title mb15"><strong>Welcome</strong></h3>
                  <p class="has-text-centered mb20 is-size-14">What should we call you ?</p>
                  <div class="field-group">
                    <div class="field">
                      <div class="control">
                        <validation-provider name="first name" ref="first_name" rules="">
                          <template #default="{ errors }">
                            <input
                              class="input"
                              name="first_name"
                              v-validate="''"
                              v-model="anomymousForm.first_name"
                              type="text"
                              placeholder="Input Name"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                    <!-- <div class="field">
                      <div class="control">
                        <validation-provider
                          name="last name"
                          ref="last_name"
                        >
                          <template #default="{ errors }">
                            <input
                              name="last_name"
                              class="input"
                              v-model="anomymousForm.last_name"
                              type="text"
                              placeholder="Last Name"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div> -->
                  </div>
                  <div class="field mt20 mb30">
                    <button
                      @click="submitAnomymousForm()"
                      class="button is-large bg-secondary hover-opacity-7 text-white is-full-width"
                    >SHOP AS GUEST</button>
                  </div>
                  <p class="text-center is-size-14 mt40 has-text-black mb10">Start enjoying member benefits!</p>

                  <div class="has-text-centered">
                    <a href="#" class="text-secondary hover-opacity-8 is-size-14 hover-text-secondary has-text-weight-semibold" @click.prevent="signUpScreen()">JOIN NOW</a>
                    <span class="has-text-weight-semibold has-text-black mr10 ml10">or</span>
                    <a href="#" class="text-secondary hover-opacity-8 is-size-14 hover-text-secondary has-text-weight-semibold" @click.prevent="signInScreen()">SIGN IN</a>
                  </div>
                  <p class="text-center is-size-11 mt30">POWERED BY <img class="powered-logo" alt="logo" src="@/assets/img/logo.png" /></p>

                </div>
                <div class="verify-token" v-else>
                  <loading v-if="showLoading"></loading>
                  <p :class="'text-center ' + (showLoading ? '': 'loaded')" v-text="msg"></p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'addAnonymous',
  data() {
    return {
      msg: 'Please wait while we are processing....',
      location: {},
      showLoading: true,
      showForm: false,
      anomymousForm: {
        first_name: '',
        last_name: '',
      },
      anonymous_user: false,
    };
  },

  computed: {
    is_user_logged_in() {
      return this.$store.getters.getLoggedInUserToken;
    },
    ...mapGetters({
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_selectedStore: "location/selected", 
      vg_businessLoyality: "businessprofile/businessLoyality",
    })
  },

  watch: {
    'vg_userId'(val) {
      // logged in on this page
      if(val){
        if(!this.anonymous_user){
          this.$router.push({ 
            name: 'StoreProfile', 
            params:{
              business_slug: this.$route.params.business_slug, 
              store_slug: this.$route.params.store_slug, 
            },
            query: this.$route.query,
          })
        }
        
      }
    },
  },

  created() {
    this.va_setSelectedLocation({});
  },

  async mounted() {
    const self = this;
    if(this.is_user_logged_in){
      self.$router.push({ 
        name: 'StoreProfile', 
        params:{
          business_slug: self.$route.params.business_slug, 
          store_slug: self.$route.params.store_slug, 
        },
        query: self.$route.query
      })
      // Do not need to show message
      // this.msg = 'Sorry you are already logged in. Redirecting...';
      // this.showLoading = false;
      // // Lets give 3 seconds to see message 
      // setTimeout(() =>{
      //   self.$router.push({ 
      //     name: 'StoreProfile', 
      //     params:{
      //       business_slug: self.$route.params.business_slug, 
      //       store_slug: self.$route.params.store_slug, 
      //     },
      //   })
      // }, 3000)
    } else {
      // First of all get business details and activate that business
      await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug); 
      let res = await LocationApis.fetchBySlug(this.$route.params.store_slug); 
      if(res.status == 200){
        this.va_setSelectedLocation(res.data.payload);
        this.location = res.data.payload;
        this.showLoading = false;
        this.showForm = true;
        // this.addAnomymous(this.anomymousForm)
      } else {
        this.msg = res.response.data.msg;
        this.showLoading = false;
      }
    }
  },

  methods: {
    async submitAnomymousForm() {
      this.anonymous_user = true;
      this.addAnomymous();
    },
    /**
     * Add anomymous user
     */
    async addAnomymous() {
      this.va_spinner(true);
      const self = this;
      let res = await LoginApis.addAnonymous({ 
          registered_from: 'budtender', // hardcoded for now
          location_id: this.location.id,
          first_name: this.anomymousForm.first_name,
          last_name: this.anomymousForm.last_name,
          business_id: this.vg_businessProfile.id ? this.vg_businessProfile.id : null,
      });
      if(res.status != 201){
        this.va_spinner(false);
        this.va_snackbar({
          type: 'warning',
          message: res.response.data.msg,
        });
      } else {
        
        

        //await this.$store.dispatch("REMOVE_APP_DATA");
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
        this.$store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: '',
          remember: false,
        });   
        
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);

        this.va_snackbar({
          type: 'success',
          message: 'Successfully logged in...',
        });
        // Fetch order history
        // let orderHistory = await OrderHistoryApis.fetch(1);
        // if(orderHistory.status == 200) {
        //   this.va_setAllOrders(orderHistory.data.payload);
        // }
        // Fetch user fav products
        //UserApis.fetchFavProducts();
        // Fetch user fav locations
        //UserApis.fetchFavLocations();
        if(!_.isEmpty(this.location) && this.location.id != ''){
          await CartApis.locationCart(this.location.id, Helpers.getLocationCartFullUrl(this));
        }

        // For Anynomous user already subscribed to business loyalty from api side so check only instore
        if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active && this.vg_userId && ( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true') )){
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name); 
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
          }
          this.va_setUserLoyalityObj({
            user_id: this.vg_userId, 
            business_id: this.vg_businessProfile.id,
          });
        }

        
        
        this.va_spinner(false);
        // We might have landed on anonymous page straight, check that to prevent double redirect
        let landedOnSamePage = this.$store.getters.getLandingRoute.indexOf('add_anonymous') < 0 ? false : true;
        if(this.$store.getters.getLandingRoute && !landedOnSamePage){
          window.location.href = this.$store.getters.getLandingRoute;
        } else {
          this.$router.push({ 
            name: 'StoreProfile', 
            params: { 
              business_slug: this.$route.params.business_slug, 
              store_slug: this.location.slug 
            }, 
            query: this.$route.query
          })
        }
        
      }
    },

     /**
     * Show signup modal
     */
    signUpScreen() {
      this.va_setSignupModal(true);
    },

    /**
     * Show login modal
     */
    signInScreen() {
      this.va_setLoginModal(true);
    },

    ...mapActions({
      va_setAllOrders: "orderhistory/setAllOrders",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setLoginModal: "loginmodal/setModal",
      va_setSignupModal: "signupmodal/setModal",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })

  },
};
</script>

<style scoped>
.verify-token {
    position: relative;
}
.verify-token p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
}
p.text-center.loaded {
  bottom: 0;
  position: relative;
  margin-top: 80px;
}
.anynomous-header{
    box-shadow: 0 0 5px #e5e5e5;
}
</style>